(function() {
  var MapSidebar;

  if (App.angularApp == null) {
    return;
  }

  MapSidebar = require('resources/assets/coffee/Core/MapSidebar').MapSidebar;

  App.angularApp.directive('mfSlideToggle', function() {
    return {
      link: function(scope, element, attrs) {
        setTimeout((function(_this) {
          return function() {
            var ref;
            return (ref = App.sidebar) != null ? ref.element.hide() : void 0;
          };
        })(this), 0);
        App.angularSidebar = new MapSidebar(App.map, element);
        return scope.$on('$destroy', function() {
          var ref;
          return (ref = App.sidebar) != null ? ref.element.show() : void 0;
        });
      }
    };
  });

}).call(this);
